var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 157,
    viewBox: "0 0 157 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_83_1793)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    rx: 75,
    transform: "matrix(-1 0 0 1 153.672 3.5)",
    fill: "#05275D",
    fillOpacity: 0.77
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: -1.5,
    width: 153,
    height: 153,
    rx: 76.5,
    transform: "matrix(-1 0 0 1 156.672 3.5)",
    stroke: "white",
    strokeWidth: 3
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90.6574 43.6871C89.5671 43.233 88.3719 43.0305 87.1664 42.9712L50.9746 42.9055C48.5731 42.8911 46.2641 43.831 44.5553 45.5186C42.8465 47.2061 41.8778 49.5032 41.8622 51.9047L41.7887 110.681C41.77 112.457 42.2721 114.199 43.2331 115.693C44.194 117.186 45.5716 118.365 47.1956 119.084C48.2859 119.539 49.4705 119.884 50.7704 119.835L87.0041 119.918C88.7595 119.907 90.4747 119.392 91.9462 118.435C93.4177 117.478 94.5838 116.118 95.3062 114.519C95.7848 113.488 96.0817 112.184 96.1585 110.937L96.0642 52.0906C96.1108 50.309 95.6199 48.5546 94.6556 47.0558C93.6913 45.557 92.2981 44.3832 90.6574 43.6871ZM105.251 49.7657L105.133 90.8077L116.225 64.1789C117.151 61.9546 117.156 59.4532 116.239 57.2252C115.321 54.9972 113.556 53.225 111.331 52.2985M125.457 65.7608L109.685 103.628L130.111 83.2988C130.951 82.457 131.618 81.4575 132.072 80.3576C132.525 79.2577 132.758 78.079 132.755 76.8892C132.752 75.6993 132.515 74.5217 132.056 73.4239C131.597 72.3261 130.926 71.3297 130.081 70.4918M87.2163 51.9484L87.1044 111.053L50.7694 110.977L50.8639 51.9142",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_83_1793",
    x: -10.3281,
    y: -10.5,
    width: 178,
    height: 178,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 5.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_83_1793"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_83_1793",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileActiveIcon);
export default __webpack_public_path__ + "static/media/mobile-active-icon.b0cc53a5f0290c1bfdcefae273d697ae.svg";
export { ForwardRef as ReactComponent };